import React from 'react';
import type { ComponentType, ElementType } from 'react';

import Tooltip from 'src/components/ui/Tooltip';

type TooltipButtonProps = {
    title: string;
    ButtonComponent: ComponentType | ElementType;
    buttonProps?: Record<string, unknown>;
    containerStyle?: Record<string, string>;
    popperPropsOffset?: number[];
    isControlled?: boolean;
    onClick?: (args: unknown) => void;
};

const TooltipButton: React.FC<TooltipButtonProps> = ({
    title,
    ButtonComponent,
    buttonProps,
    containerStyle,
    popperPropsOffset,
    isControlled,
    onClick,
}) => (
    <Tooltip
        title={title}
        placement="bottom"
        containerStyle={containerStyle ? { ...containerStyle, borderRadius: '50%' } : { borderRadius: '50%' }}
        isControlled={isControlled}
        PopperProps={{
            popperOptions: {
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: popperPropsOffset ?? [0, -10],
                        },
                    },
                ],
            },
        }}
    >
        <ButtonComponent {...buttonProps} onClick={buttonProps?.onClick ?? onClick} />
    </Tooltip>
);

export default TooltipButton;
